import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Volume2 } from 'lucide-react';

const categoryConfig = {
  tech: {
    textClass: 'text-primary',
    title: 'Syntax & Systems',
  },
  rabbit_hole: {
    textClass: 'text-deep-ochre',
    title: 'Rabbit Hole',
  },
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric',
    year: 'numeric'
  });
}

export function BlogCard({ post }) {
  const config = categoryConfig[post.category] || categoryConfig.tech;

  return (
    <motion.article
      className="group block border border-border bg-card rounded-lg overflow-hidden transition-all duration-200 hover:border-primary/50 hover:bg-muted/20 hover:shadow-lg"
      data-testid={`blog-card-${post.id}`}
      whileHover={{ y: -4 }}
    >
      <Link to={`/blog/${post.id}`} className="block">
        {/* Featured Image */}
        {post.featuredImage && (
          <div className="relative h-48 overflow-hidden">
            <img
              src={post.featuredImage}
              alt={post.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          </div>
        )}
        
        <div className="p-6">
          {/* Category & Date */}
          <div className="flex items-center justify-between mb-3">
            <span className={`text-xs font-bold uppercase tracking-widest ${config.textClass} font-body`}>
              {config.title}
            </span>
            <span className="flex items-center gap-1 text-xs text-muted-foreground font-body">
              <Calendar className="w-3 h-3" />
              {formatDate(post.created_at)}
            </span>
          </div>
          
          {/* Title */}
          <h3 className={`font-heading text-xl md:text-2xl font-semibold text-foreground mb-3 leading-tight group-hover:${config.textClass} transition-colors`}>
            {post.title}
          </h3>
          
          {/* Excerpt */}
          <p className="font-body text-muted-foreground text-sm leading-relaxed line-clamp-3 mb-4">
            {post.excerpt}
          </p>
          
          {/* Footer */}
          <div className="flex items-center justify-between">
            <span className="inline-flex items-center gap-1.5 font-body text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
              Read article
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </span>
            
            <span className="flex items-center gap-1 text-xs text-muted-foreground font-body">
              <Volume2 className="w-3 h-3" />
              Audio available
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
